import script from "./AdditionalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalInfo.vue?vue&type=style&index=0&id=d4b2c1d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4b2c1d2"]])

export default __exports__